import {FormPrintOptionsType, LabelConfigType} from '../Types';
import {AppStoreProps, ImmerStateCreator} from "./appStore";
import {
  getDefaultOrientation,
  getLabelConfig,
  isPrintOptionOrientationAvailable,
  isPrintOptionPaperColorAvailable
} from "../Utils";

export interface PrintOptionsSliceProps {
  printOptions: FormPrintOptionsType | null;
  setPrintOptions: (options: FormPrintOptionsType) => void;
}

export const createPrintOptionsSlice: ImmerStateCreator<AppStoreProps, PrintOptionsSliceProps> = (set) => {
  const printOptions = null;

  const setPrintOptions = (options: FormPrintOptionsType) => {
    set((state) => {
      const config = getLabelConfig(state.labelType);

      if (!config) {
        throw new Error('Impossible de récupérer la configuration du type d\'étiquette ' + state.labelType + '.');
      }

      manageOrientationChange(config, options);
      managePrintColorChange(config, options);
      managePaperColorChange(config, options);

      state.printOptions = options;
    });
  };

  return {
    printOptions,
    setPrintOptions,
  };
};

const manageOrientationChange = (
  config: LabelConfigType,
  options: FormPrintOptionsType,
) => {
  if (!isPrintOptionOrientationAvailable(options.size, options.orientation, config)) {
    const defaultOrientation = getDefaultOrientation(options.size, config);

    if (!defaultOrientation) {
      throw new Error('Impossible de récupérer l\'orientation par défaut pour le format ' + options.size + '.');
    }

    options.orientation = defaultOrientation;
  }
}

const managePrintColorChange = (
  config: LabelConfigType,
  options: FormPrintOptionsType,
) => {
  if (!config.printOptions.printColors.includes(options.printColor)) {
    options.printColor = config.printOptions.printColors[0];
  }
}

const managePaperColorChange = (
  config: LabelConfigType,
  options: FormPrintOptionsType,
) => {
  if (!isPrintOptionPaperColorAvailable(options.paperColor, config)) {
    options.paperColor = config.printOptions.paperColors[0];
  }
}
